<template>
  <v-app-bar app color="primary" dark>
    <v-app-bar-nav-icon v-if="iconDisplay" @click="$emit('click')" />
    <BaseDropdownMenu
      :headerText="unReadNotificationsTitle"
      :items="formattedEvents"
      @click="handleNavigateToClick"
    >
      <template #activator="{ on, attrs }">
        <BaseRoundButton :icon="bellIcon" :on="on" :attrs="attrs" />
      </template>
    </BaseDropdownMenu>
  </v-app-bar>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import BaseDropdownMenu from './BaseDropdownMenu.vue';
import BaseRoundButton from './BaseRoundButton.vue';

export default {
  name: 'TheNavBar',
  components: {
    BaseDropdownMenu,
    BaseRoundButton,
  },
  created() {
    this.fetchEvents();
  },
  methods: {
    ...mapActions(['fetchEvents', 'markEventAsSeen']),
    formatDate(date) {
      return this.$moment(date).format('L');
    },
    handleNavigateToClick(item) {
      if (!item.seen_at) {
        this.markEventAsSeen(item.id);
      }
      this.$router.push(item.link);
    },
  },
  computed: {
    ...mapState(['events']),
    iconDisplay() {
      return ['xs', 'sm'].includes(this.$vuetify.breakpoint.name);
    },
    unreadEventsCount() {
      return this.events.filter((event) => !event.seen_at).length;
    },
    unReadNotificationsTitle() {
      return `${this.$t('Unread')}  (${this.unreadEventsCount})`;
    },
    bellIcon() {
      if (this.unreadEventsCount > 0) {
        return 'mdi-bell-badge';
      }
      return 'mdi-bell';
    },
    formattedEvents() {
      const resourceTypeConfig = {
        Document: {
          iconLeft: 'mdi-text-box-multiple',
          getLink: () => '/documents',
          getDescription: (payload) => payload.name,
        },
        Test: {
          iconLeft: 'mdi-clipboard-text-outline',
          getLink: (resourceId) => `/qcm/${resourceId}`,
          getDescription: (payload) => payload.name,
        },
        Message: {
          iconLeft: 'mdi-message-text-outline',
          getLink: (resourceId, payload) => `/conversations/${payload.conversation_id}`,
          getDescription: (payload) => `Conversation avec ${payload.admin_user_name}`,
        },
        Homepage: {
          iconLeft: 'mdi-home-outline',
          getLink: () => '/',
          getDescription: (payload) => payload.title,
        },
        Evaluation: {
          iconLeft: 'mdi-trophy-variant-outline',
          getLink: () => '/notes',
          getDescription: (payload) => payload.subject_name,
        },
        Course: {
          iconLeft: 'mdi-calendar',
          getLink: () => '/plannings',
          getDescription: () => 'Des modifications ont eu lieues sur votre planning',
        },
      };

      return this.events.map((event) => {
        const { resource_type: resourceType, payload, resource_id: resourceId } = event;

        const config = resourceTypeConfig[resourceType] || {};

        const title = `New ${resourceType}`;
        const date = this.formatDate(event.created_at);
        const { iconLeft } = config;
        const link = config.getLink(resourceId, payload);
        const description = config.getDescription(payload);

        const linkText = `View ${resourceType}`;
        const iconRight = event.seen_at === null ? 'mdi-email' : 'mdi-email-open';

        return {
          iconLeft,
          title,
          date,
          description,
          link,
          linkText,
          iconRight,
          ...event,
        };
      });
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.v-toolbar__content) {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

:deep(.v-btn > .v-btn__content .v-icon.mdi.mdi-bell-badge) {
  color: #b91900;
}
</style>
